export default "__VITE_ASSET__yeANwhxt__"